import React, { useEffect } from 'react';
import { withCookies } from 'react-cookie';

import VehicleBidModality from 'components/auctions/AuctionVehicleCard/Footer/WebSalesOptions/VehicleBidModality';
import VehicleDirectPurchaseModality from 'components/shared/VehicleDirectPurchaseModality';
import VehicleRentingModality from 'components/shared/VehicleRentingModality';
import VehicleExportModality from 'components/auctions/AuctionVehicleCard/Footer/WebSalesOptions/VehicleExportModality';

import 'css/components/shared/VehicleBuyOptions.css';

const WebSalesOptions = ({
    history,
    vehicle,
    options,
    setLoadingParent,
    disableButtons,
    updateVehiclesList,
    loading,
    disabled,
}) => {
    useEffect(() => {
        if (!vehicle?.HasBidModality) {
            disableButtons(false);
            setLoadingParent(false);
        }
    }, [disableButtons, setLoadingParent, vehicle?.HasBidModality]);

    if (vehicle?.HasAgExporter) {
        return (
            <div className="c-vehicle-buy-options u-mt">
                <VehicleExportModality
                    vehicle={vehicle}
                    setLoadingParent={setLoadingParent}
                    disableButtons={disableButtons}
                    updateVehiclesList={updateVehiclesList}
                    options={options}
                    disabled={disabled}
                    loading={loading}
                />
            </div>
        );
    }

    return (
        <div className="c-vehicle-buy-options">
            {vehicle?.HasBidModality && (
                <VehicleBidModality
                    history={history}
                    vehicle={vehicle}
                    options={options}
                    setLoadingParent={setLoadingParent}
                    disableButtons={disableButtons}
                    updateVehiclesList={updateVehiclesList}
                    loading={loading}
                    disabled={disabled}
                />
            )}
            {vehicle?.HasRentingModality && (
                <VehicleRentingModality
                    history={history}
                    vehicleParent={vehicle}
                    loadingRequest={loading}
                    disabled={disabled}
                />
            )}
            {vehicle?.HasDirectPurchaseModality && (
                <VehicleDirectPurchaseModality
                    history={history}
                    options={options}
                    vehicleParent={vehicle}
                    loadingRequest={loading}
                    disabled={disabled}
                />
            )}
        </div>
    );
};

export default withCookies(WebSalesOptions);
